import React, { lazy } from 'react'

import ErrorBoundary from 'pages/ErrorBoundary'
import TselErrorPage from 'pages/TelkomselWallet/components/ErrorPage'
import { asBoolean } from 'helpers/environment'

const HelloGopay = lazy(async () => await import('../pages/HelloGopay'))
const ImaliLinking = lazy(async () => await import('../pages/Imali/Linking'))
const Linking = lazy(async () => await import('../pages/Linking'))
const LinkingConsent = lazy(
    async () => await import('../pages/Linking/LinkingConsent')
)
const UserCreation = lazy(async () => await import('../pages/UserCreation'))
const UserCreationConsent = lazy(
    async () => await import('../pages/UserCreation/UserCreationConsent')
)
const UserCreationOtp = lazy(
    async () => await import('../pages/UserCreation/UserCreationOtp')
)
const UserCreationName = lazy(
    async () => await import('../pages/UserCreation/UserCreationName')
)
const Otp = lazy(async () => await import('../pages/Linking/Otp'))
const SuccessLinking = lazy(
    async () => await import('../pages/Linking/Success')
)
const Payment = lazy(async () => await import('../pages/Payment'))
const Checkout = lazy(async () => await import('../pages/SamsungPayment'))
const OrderHistory = lazy(async () => await import('../pages/OrderHistory'))
const OrderHistoryDetail = lazy(
    async () => await import('../pages/OrderHistory/Detail')
)
const PaymentReview = lazy(
    async () => await import('../pages/SamsungPayment/PaymentReview')
)
const StaticPayment = lazy(
    async () => await import('../pages/SamsungPayment/StaticPayment')
)
const Success = lazy(
    async () => await import('../pages/SamsungPayment/Success')
)
const Failure = lazy(
    async () => await import('../pages/SamsungPayment/Failure')
)
const InAppChallenge = lazy(
    async () => await import('../pages/Payment/InAppChallenge')
)
const PaymentDetails = lazy(
    async () => await import('../pages/Payment/PaymentDetails')
)
const LoadingPayment = lazy(
    async () => await import('../pages/SamsungPayment/LoadingPayment')
)
const PaymentPin = lazy(async () => await import('../pages/Payment/Pin'))
const PaymentSuccess = lazy(
    async () => await import('../pages/Payment/Success')
)
const ChallengeFailure = lazy(
    async () => await import('../pages/Challenge/Failure')
)
const ProviderChallenge = lazy(
    async () => await import('../pages/Payment/ProviderChallenge')
)
const ProviderRedirect = lazy(
    async () => await import('../pages/Payment/ProviderRedirect')
)

const PaymentAgreement = lazy(
    async () => await import('../pages/Payment/ProviderChallenge/Agreement')
)

const AgreementPreview = lazy(
    async () => await import('../pages/Payment/Agreement')
)

const PayByPhone = lazy(async () => await import('../pages/PayByPhone'))

const TelkomselWallet = lazy(
    async () => await import('../pages/TelkomselWallet')
)

const TransactionHistory = lazy(
    async () => await import('../pages/TelkomselWallet/TransactionHistory')
)

const Faq = lazy(async () => await import('../pages/TelkomselWallet/Faq'))

const TelkomselWalletPage = lazy(
    async () =>
        await import('../pages/TelkomselWallet/components/TelkomselWalletPage')
)

const routes = [
    {
        path: '/',
        element: <HelloGopay />,
        errorElement: <ErrorBoundary />,
    },
    {
        path: 'imali/links',
        element: <ImaliLinking />,
        errorElement: <ErrorBoundary />,
    },
    {
        path: 'app/order-history',
        element: <OrderHistory />,
        errorElement: <ErrorBoundary />,
    },
    {
        path: 'order-history/:orderId',
        element: <OrderHistoryDetail />,
        errorElement: <ErrorBoundary />,
    },
    {
        path: 'user',
        element: <TelkomselWallet />,
        errorElement: <TselErrorPage />,
        children: [
            {
                path: 'dashboard',
                element: <TelkomselWalletPage />,
                errorElement: <TselErrorPage />,
            },
            {
                path: 'transaction-history',
                element: <TransactionHistory />,
                errorElement: <TselErrorPage />,
            },
            {
                path: 'transaction-history/:transactionId',
                element: <TransactionHistory />,
                errorElement: <TselErrorPage />,
            },
            {
                path: 'information-center',
                element: <Faq />,
                errorElement: <TselErrorPage />,
            },
        ],
    },
]

if (asBoolean(process.env.REACT_APP_IS_LINKING_FLOW_ENABLED)) {
    const linkingRoutes = [
        {
            path: 'app/authorize',
            element: <Linking />,
            errorElement: <ErrorBoundary />,
        },
        {
            path: 'app/user-creation',
            element: <UserCreation />,
            errorElement: <ErrorBoundary />,
        },
        {
            path: '/user-creation',
            element: <UserCreation />,
            errorElement: <ErrorBoundary />,
            children: [
                {
                    path: 'consent',
                    element: <UserCreationConsent />,
                    errorElement: <ErrorBoundary />,
                },
                {
                    path: 'otp',
                    element: <UserCreationOtp />,
                    errorElement: <ErrorBoundary />,
                },
                {
                    path: 'name',
                    element: <UserCreationName />,
                    errorElement: <ErrorBoundary />,
                },
            ],
        },
        {
            path: '/linking',
            element: <Linking />,
            errorElement: <ErrorBoundary />,
            children: [
                {
                    path: 'consent',
                    element: <LinkingConsent />,
                    errorElement: <ErrorBoundary />,
                },
                {
                    path: 'otp',
                    element: <Otp />,
                    errorElement: <ErrorBoundary />,
                },
                {
                    path: 'success',
                    element: <SuccessLinking />,
                    errorElement: <ErrorBoundary />,
                },
            ],
        },
    ]

    routes.push(...linkingRoutes)
}

if (asBoolean(process.env.REACT_APP_IS_SAMSUNG_PAYMENT_FLOW_ENABLED)) {
    const checkoutRoutes = [
        {
            path: 'app/checkout',
            element: <Checkout />,
            errorElement: <ErrorBoundary />,
        },
        {
            path: '/checkout',
            element: <Checkout />,
            errorElement: <ErrorBoundary />,
            children: [
                {
                    path: 'payment-review',
                    element: <PaymentReview />,
                    errorElement: <ErrorBoundary />,
                },
                {
                    path: 'static-payment',
                    element: <StaticPayment />,
                    errorElement: <ErrorBoundary />,
                },
                ...(asBoolean(process.env.REACT_APP_IS_OFF_US_FLOW_ENABLED)
                    ? [
                          {
                              path: 'loading-payment',
                              element: <LoadingPayment />,
                              errorElement: <ErrorBoundary />,
                          },
                      ]
                    : []),
                {
                    path: 'success',
                    element: <Success />,
                    errorElement: <ErrorBoundary />,
                },
                {
                    path: 'failure',
                    element: <Failure />,
                    errorElement: <ErrorBoundary />,
                },
            ],
        },
    ]

    routes.push(...checkoutRoutes)
}

if (asBoolean(process.env.REACT_APP_IS_PAYMENT_FLOW_ENABLED)) {
    const paymentRoutes = [
        {
            path: 'app/challenge',
            element: <Payment />,
            errorElement: <ErrorBoundary />,
        },
        {
            path: '/payment',
            element: <Payment />,
            errorElement: <ErrorBoundary />,
            children: [
                {
                    path: 'details',
                    element: <PaymentDetails />,
                    errorElement: <ErrorBoundary />,
                },
                {
                    path: 'validate-pin',
                    element: <PaymentPin />,
                    errorElement: <ErrorBoundary />,
                },
                {
                    path: 'success',
                    element: <PaymentSuccess />,
                    errorElement: <ErrorBoundary />,
                },
            ],
        },
    ]

    routes.push(...paymentRoutes)
}

if (asBoolean(process.env.REACT_APP_IS_JAGO_2FA_ON_TOKOPEDIA_ENABLED)) {
    const paymentProviderRoutes = {
        path: 'payment/provider-challenge',
        element: <ProviderChallenge />,
        errorElement: <ErrorBoundary />,
        children: [
            {
                path: 'agreement',
                element: <PaymentAgreement />,
                errorElement: <ErrorBoundary />,
            },
        ],
    }
    routes.push(paymentProviderRoutes)

    routes.push({
        path: 'payment/provider-redirect',
        element: <ProviderRedirect />,
        errorElement: <ErrorBoundary />,
    })

    routes.push({
        path: 'payment/challenge-redirect', // Try 'payment/challenge/redirect' to check if works!
        element: <ProviderRedirect />,
        errorElement: <ErrorBoundary />,
    })

    const challengeRoutes = {
        path: 'payment/challenge',
        element: <ProviderChallenge />,
        errorElement: <ErrorBoundary />,
        children: [
            {
                path: 'success',
                element: <PaymentSuccess />,
                errorElement: <ErrorBoundary />,
            },
            {
                path: 'failed',
                element: <ChallengeFailure />,
                errorElement: <ErrorBoundary />,
            },
            {
                path: 'agreement',
                element: <PaymentAgreement />,
                errorElement: <ErrorBoundary />,
            },
            {
                path: 'instructions',
                element: <InAppChallenge />,
                errorElement: <ErrorBoundary />,
            },
        ],
    }
    routes.push(challengeRoutes)

    if (asBoolean(process.env.REACT_APP_IS_PAYMENT_AGREEMENT_PREVIEW_ENABLED)) {
        const agreementRoutes = {
            path: 'payment/agreement/preview',
            element: <AgreementPreview />,
            errorElement: <ErrorBoundary />,
        }
        routes.push(agreementRoutes)
    }
}

if (asBoolean(process.env.REACT_APP_IS_PBP_FLOW_ENABLED)) {
    const pbpRoutes = [
        {
            path: '/v2/payment/phone',
            element: <PayByPhone />,
            errorElement: <ErrorBoundary />,
        },
    ]

    routes.push(...pbpRoutes)
}

export default routes
